import {autoinject} from "aurelia-framework";
import "./app.scss";
import {RouterConfiguration, Router, Next, NavigationInstruction} from 'aurelia-router';
import {PLATFORM} from "aurelia-pal";
import {CartConfig} from "./shopping-cart/shopping-cart";


@autoinject()
export class App {

  public router: Router;

  private cartConfig: CartConfig = new CartConfig();

  configureRouter(config: RouterConfiguration, router: Router): void {
    this.router = router;
    config.addPreActivateStep(new HideShoppingCart((value) => {
      this.cartConfig = value
    }));
    config.addPostRenderStep(new TrackPageView());
    config.map([
      {route: ['', 'page1-intro'], name: 'Intro', moduleId: PLATFORM.moduleName('pages/page1-intro')},
      {route: ['page2-amount'], name: 'Amount', moduleId: PLATFORM.moduleName('pages/page2-amount')},
      {route: ['page3-cart'], name: 'Shopping Cart', moduleId: PLATFORM.moduleName('pages/page3-cart')},
      {route: ['page4-address'], name: 'Address', moduleId: PLATFORM.moduleName('pages/page4-address')},
      {route: ['page5-confirm'], name: 'Confirm', moduleId: PLATFORM.moduleName('pages/page5-confirm')},
      {
        route: ['page6-paymentinformation'],
        name: 'Confirm',
        moduleId: PLATFORM.moduleName('pages/page6-paymentInformation')
      },
      {route: ['success'], name: 'Success', moduleId: PLATFORM.moduleName('pages/page_success')},
      {route: ['cancel'], name: 'cancel', moduleId: PLATFORM.moduleName('pages/page_cancel')},
      {route: ['error'], name: 'Error', moduleId: PLATFORM.moduleName('pages/page_error')},
      {route: ['decline'], name: 'Decline', moduleId: PLATFORM.moduleName('pages/page_declined')}
    ]);
  }
}

export class HideShoppingCart {
  run(navigationInstruction: NavigationInstruction, next: Next): Promise<CartConfig> {
    let showCart = true;
    if (navigationInstruction.fragment) {
      if (navigationInstruction.fragment === '/' ||
        navigationInstruction.fragment === '/page1-intro' ||
        navigationInstruction.fragment === '/success' ||
        navigationInstruction.fragment === '/page3-cart' ||
        navigationInstruction.fragment === '/page6-paymentinformation'
      ) {
        showCart = false;
      }
    }
    let showCouponImage = navigationInstruction.fragment !== '/page2-amount';

    this.callback(new CartConfig(showCart, showCouponImage));
    return next();
  }

  constructor(private callback: (n: CartConfig) => void) {

  }
}

export class TrackPageView {

  run(navigationInstruction: NavigationInstruction, next: Next): Promise<any> {
    try {
      NY_TRACKER.trackPage(navigationInstruction.fragment, navigationInstruction.config.title);
    } catch (e) {
      console.log("no tracking initialized")
    }
    return next();
  }
}
